export default "__VITE_ASSET__brDDZgKM__"